import { useState } from "react"


const NSNForm = ({setNsnData, setItemData, setRefData, setCharData}) => {

    //create state
    const [nsn, setNsn] = useState('')
    const [error, setError] = useState('')

    var niin = nsn.slice(4)
    
    
    

    const handleSubmit = async (e) =>{
        e.preventDefault()

        //get contract history
        const nsnurl = 'https://postgres-nsn-search-tau.vercel.app/api/nsn/' + nsn;

        const nsnResponse = await fetch(nsnurl, {
            method:'GET'
        })
        const data = await nsnResponse.json()
        console.log(data)
        if(!nsnResponse.ok){
            setError(data.error)
            console.log(error)
        }else{
            setNsn('')
            setNsnData(data)
            setError(null)
            
            
        }


        //get item nsn info
        const itemURL = 'https://postgres-nsn-search-tau.vercel.app/api/item/' + niin;

        const itemResponse = await fetch(itemURL, {
            method:'GET'
        })
        const itemData = await itemResponse.json()
        
        if(!itemResponse.ok){
            setError(itemData.error)
        }else{
            setItemData(itemData)
            setError(null)
        }

        //get part number reference
        const refURL = 'https://postgres-nsn-search-tau.vercel.app/api/ref/' + niin;
        const refResponse = await fetch (refURL, {
            method:'GET'
        })
        const refData = await refResponse.json()
        if(!refResponse.ok){
            setError(refData.error)
        }else{
            setRefData(refData)
            setError(null)
        }

        //get characteristics
        const charURL = 'https://postgres-nsn-search-tau.vercel.app/api/char/' + niin;
        const charResponse = await fetch (charURL, {
            method:'GET'
        })
        const charData = await charResponse.json()
        if(!charResponse.ok){
            setError(charData.error)
        }else{
            setCharData(charData)
            setError(null)
        }

    }

    return(
    
       <form className="search" onSubmit={handleSubmit}>
        <h3>Search for a NSN</h3>
        <input
            type="number"
            name="nsnInput"
            onChange={(e) => setNsn(e.target.value)}
            value={nsn}
        />

        <button>Enter</button>
        
       </form>
    

    )
}

export default NSNForm;